import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=64a66010&scoped=true&"
import script from "./claim.vue?vue&type=script&lang=js&"
export * from "./claim.vue?vue&type=script&lang=js&"
import style0 from "./claim.vue?vue&type=style&index=0&id=64a66010&scoped=true&lang=css&"
import style1 from "./claim.vue?vue&type=style&index=1&id=64a66010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a66010",
  null
  
)

export default component.exports